import { IAppConfigStore } from "../interfaces/IAppState"
import { AppConfigActionType } from "../constants/actionTypes"

function init() {
	return {} as IAppConfigStore
}

export const appConfigReducer = function (initialState = init(), action: any) {
	switch (action.type) {
		case AppConfigActionType.UPDATE_HMS_RECORDING_COACH_LIST:
			return {
				...initialState,
				enabledHMSCallRecordingCoaches: action.payload,
			}
		case AppConfigActionType.UPDATE_TRANSCRIPTION_ENABLED_AGENT_LIST:
			return {
				...initialState,
				transcriptionEnabledAgents: action.payload,
			}
		case AppConfigActionType.UPDATE_CONSULT_AUDIO_RECORDING_DURATION_IN_SEC:
			return {
				...initialState,
				consultAudioRecordingDurationInSec: Math.max(action.payload || 0, 10),
			}
		case AppConfigActionType.UPDATE_DOCTOR_IDS_TO_ENABLE_MEDICATION_SCORE_FEATURE:
			return {
				...initialState,
				doctorIdsToEnableMedicationScoreFeature: action.payload,
			}
		case AppConfigActionType.UPDATE_CHS_METRIC_ID_MAP:
			return {
				...initialState,
				chsMetricIdMap: action.payload,
			}
		case AppConfigActionType.UPDATE_RATING_CONFIG:
			return {
				...initialState,
				ratingConfig: action.payload,
			}
		case AppConfigActionType.UPDATE_WC_SCRIPT_TAGS_CONFIG:
			return {
				...initialState,
				wcScriptTagsConfig: action.payload,
			}
		case AppConfigActionType.UPDATE_CHAT_FEATURE_CONFIG:
			return {
				...initialState,
				chatFeatureConfig: action.payload,
			}
		case AppConfigActionType.UPDATE_AI_FEATURE_FLAGS_CONFIG:
			return {
				...initialState,
				aiFeatureFlagConfig: action.payload,
			}
		case AppConfigActionType.UPDATE_DOCTOR_IDS_TO_ENABLE_GLP_CARE_TEAM:
			return {
				...initialState,
				doctorIdsToEnableGlpCareTeam: action.payload,
			}
		default:
			return initialState
	}
}
